import api from "../api"
import { TenantDTO, TenantForSidebarDto, TenantUpdateDTO } from "./tenantsModel"

export const tenantsEndpoint = `/tenants`

export const applyCustomerDisplayAs = async (): Promise<string> => {
  return (await api.get<string>(tenantsEndpoint + '/apply-customer-display-as')).data
}

export const getTenant = async (tenantId: number | undefined): Promise<TenantDTO> => {
  return (await api.get<TenantDTO>(tenantsEndpoint + '/' + tenantId)).data
}

export const getTenantsListForSidebar = async (): Promise<TenantForSidebarDto[]> => {
  return (await api.get<TenantDTO[]>(tenantsEndpoint)).data
}

export type TimeZoneDto = {
  timeZones: {
    disabled: boolean
    group?: any
    selected: boolean
    text: string
    value: string
  }[]
}

export const getTimeZones = async (): Promise<TimeZoneDto> => {
  return (await api.get<TimeZoneDto>(tenantsEndpoint + '/timezones')).data
}

export const saveTenant = async (tenant: TenantUpdateDTO): Promise<TenantDTO> => {
  return (await api.post<TenantDTO>(tenantsEndpoint, tenant)).data
}

export const completeAccountConfig = async (tenantId: number): Promise<void> => {
  await api.post(`${tenantsEndpoint}/${tenantId}/complete-account-config`)
}